"use strict";

PF.Models = class Models extends PF.Entity.Array
{
	static get options()
	{
		return {
			raw: [],
			loadOnInit: true,

			offline: false,

			baseUrl: '/',
			representUrl: `/represent/@{action}?represent=@{represent}&dicts=@{urlLoadDicts}&count=true&meta=@{urlLoadMeta}`,
			dictUrl: `/represent/getDict?represent=@{represent}&dictName=@{dictName}`,
			dictName: undefined,

			represent: undefined,
			urlLoadDicts: true,
			urlLoadMeta: false,

			idIndex: "id",
			limit: Infinity,
			where: "",
			order: "",
			dictMaps: {},
			filterConfig: {},
			filterDebounceMethod: 'onFinish',
			filterDebounceDelay: 500,
			filterLocalFlag: false,

			deletePolicy: undefined, //delete, deleteByFlag, unlinkByFlag
			newItemData: {},
			getNewId: PF.H.createUUID,
			parentLink: undefined,
		};
	}

	init()
	{
		// this.initStatus = 'notInit';
		if (this.deletePolicy === undefined)
		{
			this.deletePolicy = this.represent !== undefined ? 'delete' : 'deleteByFlag';
		}

		this.onChange('parentLink', () => this.setupByParent());
		this.onChange('parent', () => this.setupByParent());
		this.setupByParent();

		this.clear();

		this.populateData(this.raw, 'append');

		this.setFilterByConfig(this.filterConfig);

		this.filterLocal();

		if (this.represent === undefined)
		{
			this.dataStatus = 'allLoaded';
			this.count = this.length;
		}

		if (this.loadOnInit === true)
		{
			this.loadPart();
		}

		this.trigger('load-part');

		this.on('changed', () =>
		{
			this.hasModify = true;
			if (this.parent !== undefined && this.makeRemoteChanges() === false)
			{
				this.parent.trigger('changed');
			}
		});

		// this.calc('initStatus', ['represent', 'count'], (r, c) => r === undefined ? 'init' : (isFinite(c) ? 'init' : 'notInit'));
	}

	setupByParent()
	{
		if (this.parentLink !== undefined && this.parent !== undefined)
		{
			this.newItemData = () =>
			{
				let data = {};
				for (let key in this.parentLink)
				{
					data[key] = this.parent.get(this.parentLink[key]);
				}
				return data;
			};

			this.where = () =>
			{
				let conditions = [];
				for (let key in this.parentLink)
				{
					if (this.parent.get(this.parentLink[key], null) !== null)
					{
						conditions.push(`${key} = '${this.parent.get(this.parentLink[key])}'`);
					} else
					{
						conditions.push(`${key} is null`);
					}
				}
				return conditions.join(' AND ');
			};
		}
	}

	clear()
	{
		this.splice(0, this.length);
		this.count = Infinity;
		this.firstLoad = true;
		this.idMap = new Map();
		this.modified = new PF.Entity.Set();
		this.deleted = new PF.Entity.Set();
		this.hasModify = false;
		this.loadQueue = [];
		this.filterLength = 0;
		this.notRemovedCount = 0;
		this.dicts = {};
		this.loading = false;
		this.clearTs = new Date();
		this.currentConfig = undefined;
		this.dataStatus = 'notLoaded';
	}

	setFilterByConfig(filterConfig)
	{
		filterConfig.models = this;
		this.setFilter(new PF.Filter(filterConfig));
	}

	setFilter(filter)
	{
		this.filter = filter;
		this.filter.models = this;
		this.filter[this.filterDebounceMethod]('change', () => this.filterChanged(), this.filterDebounceDelay);
		this.filter[this.filterDebounceMethod]('change-r', () => this.reload(), this.filterDebounceDelay);
		this.filter[this.filterDebounceMethod]('change-l', () => this.filterLocal(), this.filterDebounceDelay);
	}

	reload()
	{
		this.clear();

		this.loadPart();
	}

	update(limit = this.length)
	{
		for (let i = 0; i < this.loadQueue.length; i++)
		{
			if (this.loadQueue[i].policy === "update")
			{
				this.loadQueue.splice(i, 1);
				i--;
			}
		}

		this.loadQueue.push({ policy: 'update', limit: Math.max(limit, this.limit), offset: 0 });
		this.tryLoad();
	}

	loadPart()
	{
		if (this.filterLength < this.count)
		{
			if (this.currentConfig !== undefined)
			{
				if (this.currentConfig.limit === this.limit && this.currentConfig.offset === this.length)
				{
					return;
				}
			}

			let queryHasConfig = false;
			let end = 0;
			for (let i = 0; i < this.loadQueue.length; i++)
			{
				if (this.loadQueue[i].policy !== "append")
				{
					end = i;
					break;
				}
				if (this.loadQueue[i].limit === this.limit && this.loadQueue[i].offset === this.length)
				{
					queryHasConfig = true;
				}
			}
			if (queryHasConfig === false)
			{
				this.loadQueue.splice(end, 0, { policy: 'append', limit: this.limit, offset: this.length });
			}
			this.tryLoad();
		}
	}

	loadCount()
	{
		if (!isFinite(this.count))
		{
			this.loadQueue.push({ policy: 'count' });
			this.tryLoad();
		}
	}


	tryLoad()
	{
		if (this.loading === false && this.represent !== undefined)
		{
			this.currentConfig = this.loadQueue.shift();
			if (this.currentConfig !== undefined)
			{
				this.load(this.currentConfig.policy, this.currentConfig.limit, this.currentConfig.offset);
			}
		}
	}

	load(policy, limit = this.limit, offset = this.length)
	{
		this.loading = true;
		let loadTs = new Date();

		if (app.online === false)
		{
			this.addPart(JSON.parse(localStorage.getItem(this.represent)), policy, loadTs);
		}

		let dictMaps = {};
		for (let dictName in this.dictMaps)
		{
			dictMaps[dictName + 'Schema'] = this.dictMaps[dictName];
		}

		let params = {};
		for (let name in this.params)
		{
			params[name] = PF.applyContext(this.params[name], this, null);
		}

		let key = this.dictName === undefined ? 'schema' : this.dictName + 'Schema';

		let requestData = {
			[key]: {
				filters: this.filter.toJSON(),
				where: typeof this.where === 'function' ? this.where(this) : this.where,
				limit: limit,
				offset: offset,
				order: this.order,
			},
			...dictMaps,
			...params,
		};


		let url = this.dictName === undefined ? this.representUrl : this.dictUrl;
		let urlContext = {
			represent: this.represent,
			action: policy === 'count' ? 'count' : 'all',
			urlLoadDicts: this.urlLoadDicts && this.firstLoad,
			urlLoadMeta: this.urlLoadMeta && this.firstLoad,
			dictName: this.dictName,
		};

		app.request(this.applyContext(url, urlContext), requestData, (response) => this.addPart(response, policy, loadTs), () =>
		{
			app.online = false;
			if (this.offline === true)
			{
				this.addPart(JSON.parse(localStorage.getItem(this.represent)), policy, loadTs);
			}
		});
	}

	addPart(response, policy, loadTs)
	{
		if (this.clearTs > loadTs)
		{
			// console.log('ignore data by ts');
			return;
		}
		if (response.count !== undefined)
		{
			this.count = parseInt(response.count);
		}
		if (response.meta !== undefined)
		{
			this.meta = response.meta;
		}
		if (this.firstLoad === true)
		{
			if (response.dicts !== undefined)
			{
				for (let dictName in response.dicts)
				{
					this.dicts[dictName] = new PF.Models({ raw: response.dicts[dictName].data });
				}
			}
		}

		if (response.data !== undefined)
		{
			this.populateData(response.data, policy);
		}

		this.filterLocal();

		if (policy === 'count')
		{
			this.trigger('load-count');
		}
		else
		{
			if (this.length === this.count)
			{
				this.dataStatus = 'partLoaded';
				this.dataStatus = 'allLoaded';
			}
			else
			{
				this.dataStatus = 'partLoaded';
			}

			if (this.firstLoad === true)
			{
				this.trigger('load-first');
				this.firstLoad = false;
			}
			this.trigger('load-part');
		}

		this.toLocalStorage();

		this.loading = false;
		this.currentConfig = undefined;
		this.tryLoad();
	}

	toLocalStorage()
	{
		if (this.offline)
		{
			localStorage.setItem(this.represent, JSON.stringify({ data: this.toJSON(), count: this.count }));
		}
	}

	populateData(array, policy)
	{
		let arrayMap = {};
		for (let i = 0; i < array.length; i++)
		{
			let id = PF.H.get(array[i], this.idIndex, PF.H.createUUID());
			arrayMap[id] = {
				item: array[i]
			};
		}

		let indexesForRemove = [];

		for (let i = 0; i < this.length; i++)
		{
			let id = PF.H.get(this[i], this.idIndex);
			if (id in arrayMap)
			{
				this[i].populateData(arrayMap[id].item);
				arrayMap[id].inTarget = true;
			}
			else
			{
				indexesForRemove.push(i);
			}
			// for (let j = 0; j < array.length; j++)
			// 	{
			// 	if (PF.H.compareByPks(this[i], array[j]))
			// 		{
			// 		this[i].populateData(array[j]);
			// 		array[j].inTarget = true;
			// 		this[i].inArray = true;
			// 		break;
			// 		}
			// 	}
		}
		if (policy === 'update')
		{
			for (let i = 0; i < indexesForRemove.length; i++)
			{
				this.splice(indexesForRemove[i], 1);
			}
			// for (let i = 0; i < this.length; i++)
			// 	{
			// 	if (this[i].inArray !== true && this[i].isNull() === false)
			// 		{
			// 		this.splice(i, 1);
			// 		i--;
			// 		}
			// 	}
		}
		// for (let i = 0; i < array.length; i++)
		for (let id in arrayMap)
		{
			if (arrayMap[id].inTarget !== true)
			{
				let item = arrayMap[id].item;
				if (item.constructor.name === 'Object')
				{
					let modelItem;
					if (this.idMap.has(PF.H.get(item, this.idIndex)))
					{
						modelItem = this.idMap.get(PF.H.get(item, this.idIndex));
					}
					else
					{
						modelItem = this.createItem(item);
					}
					this.push(modelItem);
				}
				else if (item.constructor.name === 'Array')
				{
					this.push(new PF.Models({ raw: item }));
				}
				else
				{
					this.push(item);
				}
			}
		}
		// for (let i = 0; i < this.length; i++)
		// 	{
		// this[i].inTarget = undefined;
		// this[i].inArray = undefined;
		// }
	}

	createItem(data, options = {})
	{
		let item = PF.Model.create(data, { models: this, ...options, parent: this, dicts: this.dicts });
		this.connectItem(item);
		return item;
	}

	connectItem(item)
	{
		if (PF.H.get(item, this.idIndex, null, null) === null)
		{
			item.set(this.idIndex, PF.H.randomString());
		}
		this.idMap.set(PF.H.get(item, this.idIndex), item);
		item.on('changed', () =>
		{
			this.modified.add(item);
		});
		item.on('save-local', () =>
		{
			this.save();
		});
		item.onValue('options.filterShow', true, () => this.filterLength++);
		item.onValue('options.filterShow', false, () => this.filterLength--);

		item.onValue('options.removed', true, () => this.notRemovedCount--);
		item.onValue('options.removed', false, () => this.notRemovedCount++);
	}

	createNewItem(data = {})
	{
		let newId = typeof this.getNewId === 'function' ? this.getNewId() : this.getNewId;
		let newItemData = typeof this.newItemData === 'function' ? this.newItemData(this) : this.newItemData;

		let item = this.createItem({ ...newItemData, [this.idIndex]: newId, ...data }, { isNewRecord: true });
		// this.connectItem(item);
		return item;
	}

	makeRemoteChanges()
	{
		if (this.represent !== undefined)
		{
			let parent = this.parent;
			while (parent !== undefined)
			{
				if (parent.isNewRecord === true)
				{
					return false;
				}
				parent = parent.parent;
			}
			return true;
		}
		return false;
	}

	save()
	{
		if (this.modified.size > 0)
		{
			if (this.makeRemoteChanges() === true)
			{
				let requestData = {
					rows: this.modified.toJSON()
				};
				this.modified.clear();
				let urlContext = {
					represent: this.represent,
					action: 'save',
				};

				app.request(this.applyContext(this.representUrl, urlContext), requestData, (response) => this.saveSuccess(response));
			}
			else
			{
				this.trigger('changed');
			}
		}
	}

	saveSuccess(response)
	{
		for (let i = 0; i < response.length; i++)
		{
			let id = PF.H.get(response[i].row, this.idIndex);
			let item = this.idMap.get(id);
			item.saveSuccess(response[i]);

		}
		this.trigger('save-modified-success');
		// this.hasModify = false;
	}

	delete()
	{
		if (this.deleted.size > 0)
		{
			if (this.makeRemoteChanges() === true)
			{
				let requestData = {
					rows: this.deleted.toJSON()
				};
				let urlContext = {
					represent: this.represent,
					action: 'delete',
				};

				app.request(this.applyContext(this.representUrl, urlContext), requestData, (response) => this.deleteSuccess(response));
			}
			else
			{
				for (let item of this.deleted)
				{
					this.removeModel(item);
				}
				this.trigger('changed');
			}
		}
	}

	deleteSuccess(response)
	{
		let allSuccess = true;
		for (let i = 0; i < response.length; i++)
		{
			if (response[i].status === "OK")
			{
				let id = PF.H.get(response[i].sourceRow, this.idIndex);
				let item = this.idMap.get(id);
				item.trigger('delete-success');
				this.deleted.delete(item);

				let index = this.indexOf(item);
				this.splice(index, 1);
				this.idMap.delete(id);
			}
			else
			{
				allSuccess = false;
				app.toast("Ошибка при удалении записи. Убедитесь что от отданной записи не зависят другие.");
			}
		}
		if (allSuccess === true)
		{
			this.trigger('delete-marked-success');
		}
	}

	filterLocal()
	{
		if (this.filterLocalFlag === true)
		{
			for (let i = 0; i < this.length; i++)
			{
				if (this[i] instanceof PF.Model)
				{
					this[i].options.filterShow = this.filter.check(this[i]);
				}
			}
		}
	}

	filterChanged()
	{
		if (this.represent !== undefined)
		{
			this.reload();
		}
		else
		{
			this.filterLocal();
		}
	}

	addModel(model)
	{
		let modelFromList = this.findByModel(model);
		if (modelFromList === undefined)
		{
			modelFromList = this.createItem(model.toJSON());
			this.push(modelFromList);
			this.modified.add(modelFromList);
			this.idMap.set(modelFromList.get('id'), modelFromList);
			this.trigger('changed');
		}
		else
		{
			if (modelFromList.options.removed === true)
			{
				modelFromList.options.removed = false;
				if (this.deletePolicy === 'deleteByFlag')
				{
					modelFromList.setData('#delete', false);
				}
				if (this.deletePolicy === 'unlinkByFlag')
				{
					modelFromList.setData('#unlink', false);
				}
			}
		}
	}

	removeModel(model)
	{
		let modelFromList = this.findByModel(model);
		if (modelFromList !== undefined)
		{
			modelFromList.options.removed = true;
			// modelFromList.options.parent = this;
			if (this.deletePolicy === 'deleteByFlag')
			{
				modelFromList.setData('#delete', true);
			}
			if (this.deletePolicy === 'unlinkByFlag')
			{
				modelFromList.setData('#unlink', true);
			}
			if (this.deletePolicy === 'delete')
			{
				let index = this.indexOf(modelFromList);
				this.splice(index, 1);
				this.trigger('changed');
			}
		}
	}

	findByModel(model)
	{
		let index = this.indexOf(model);
		if (index >= 0)
		{
			return this[index];
		}
		for (let i = 0; i < this.length; i++)
		{
			if (PF.H.compareByPks(this[i], model))
			{
				return this[i];
			}
		}
		return undefined;
	}

	destroy()
	{
		this.filter.destroy();
		super.destroy();
		// this.filter.models = undefined;
		// this.filter = undefined;
	}

};


